import ElementController from "../base-controllers/ElementController.js";
import { ActionEvent } from "./action/constants.js";
/**
 * Reset Chatwoot widget when logging out.
 * Used on an action button.
 */
class ChatwootReset extends ElementController {
    constructor() {
        super(...arguments);
        this.afterSubmission = () => {
            window.$chatwoot.reset();
        };
    }
}
ChatwootReset.id = "ChatwootReset";
ChatwootReset.binds = {
    root: [[ActionEvent.afterSubmission, "afterSubmission"]],
};
export default ChatwootReset;
//# sourceMappingURL=ChatwootReset.js.map